// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const roggenrola: PokeData = {
  "id": 524,
  "name": "roggenrola",
  "height": 4,
  "weight": 180,
  "base_experience": 56,
  "types": [
    PokeType.ROCK
  ],
  "api_moves": [
    "sand-attack",
    "headbutt",
    "tackle",
    "harden",
    "explosion",
    "rock-slide",
    "mud-slap",
    "sandstorm",
    "iron-defense",
    "rock-blast",
    "stone-edge",
    "stealth-rock",
    "smack-down"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "rock-slide",
    "mud-slap",
    "sandstorm",
    "rock-blast",
    "stealth-rock",
    "rock-throw",
    "rock-tomb",
    "seismic-toss",
    "ancient-power",
    "rock-smash",
    "stone-crush"
  ],
  "evolution_chain": {
    "id": 268,
    "item": null,
    "species": [
      {
        "name": "roggenrola",
        "order": 525,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "boldore",
        "order": 526,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": 524,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "gigalith",
        "order": 527,
        "types": [
          PokeType.ROCK
        ],
        "evolves_from_species_id": 525,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55,
    "speed": 15,
    "ability_power": 75
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
